import Styles from '@/assets/js/Styles';
import Container from '@/components/Container';
import React, { useState } from 'react';
import { Button, Snackbar, Alert, Typography } from '@mui/material';
import { Api } from '@/services/Api';

export const UpdateDomainUrls = () => {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });

  const onClickUpdateDomainUrls = async () => {
    setLoading(true);
    try {
      Api.updateDomainUrls();
      setSnackbar({ open: true, message: 'Domenene ble oppdatert.', severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: 'Feil under oppdatering av domener.', severity: 'error' });
      console.error('Feil under oppdatering av domener:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      column
      fullWidth
      sx={{
        p: 4,
        border: `1px solid ${Styles.Colors.MEDIUM_LIGHT_GREY}`,
        borderRadius: Styles.Dimensions.RADIUS_ROUNDNESS_DEFAULT,
      }}>
      <Container left fullWidth>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>Oppdater domenenavn</Typography>
      </Container>
      <Container left fullWidth sx={{ marginTop: 2 }}>
        <Typography>
          Denne funksjonen vil oppdatere alle domenenavn i databasen til å matche ditt nåværende miljø.
        </Typography>
      </Container>
      <Container>
        <Button
          onClick={onClickUpdateDomainUrls}
          color='primary'
          variant='contained'
          sx={{ marginTop: 2 }}
          disabled={loading}>
          Sett i gang
        </Button>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}>
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </Container>
  );
};
